import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CircleLoadingIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M11.9091 21C16.9299 21 21 16.9299 21 11.9091C21 6.88831 16.9299 2.81818 11.9091 2.81818C6.88831 2.81818 2.81818 6.88831 2.81818 11.9091C2.81818 16.9299 6.88831 21 11.9091 21Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
      />
      <path
        d="M4.63636 11.9091C4.63636 9.98024 5.4026 8.1304 6.7665 6.7665C8.1304 5.4026 9.98024 4.63636 11.9091 4.63636V1C5.88455 1 1 5.88455 1 11.9091H4.63636ZM6.45455 16.7191C5.28019 15.3923 4.63328 13.6809 4.63636 11.9091H1C1 14.6745 2.03182 17.2036 3.72727 19.1255L6.45455 16.7191Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CircleLoadingIcon.displayName = 'CircleLoadingIcon';
